export default __webpack_public_path__ + "static/media/risorsa2.d79d9fd6.png";